import React, { useLayoutEffect, useState } from "react";
import styled from "styled-components/macro";
import { device } from "../../device";
import { useMediaQuery } from "react-responsive";

const SuggestedProductsForRent = ({ items: fbItems, location, isPDF }) => {
  const [items, setItems] = useState(fbItems);
  useLayoutEffect(() => {
    const newItems = { ...fbItems };

    Object.keys(newItems).forEach((key) => {
      const item = { ...newItems[key].item };

      if (
        item.type !== "rentals" &&
        item.table_items &&
        item.table_items.length > 0 &&
        item.table_items[0].title
      ) {
        delete newItems[key];
        item.table_items.forEach((newItem) => {
          const category = item.category;
          const {
            eu_currency,
            il_currency,
            image,
            // : image.url,
            model,
            quantity,
            title,
            uk_currency,
            us_currency,
          } = newItem;

          if (title) {
            newItems[title] = {};

            newItems[title].count = quantity;
            newItems[title].item = {
              category,
              title,
              eu_currency,
              il_currency,
              image: image.url,
              model,
              uk_currency,
              us_currency,
            };
          }
        });
      }
    });

    setItems(newItems);
  }, [fbItems]);

  const firstItem = fbItems && Object.values(fbItems)[0]?.item;

  const isShop = firstItem?.type === "shop";
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const permanentKey = "Rental item | ";
  const sortingOrder = [
    "Clean",
    "Play",
    "Cook",
    "Host",
    "Fitness",
    "DIY",
    "OutDoor",
    "Ride",
  ].map((item) => {
    if (item === "Ride") {
      return item;
    }
    const key = permanentKey + item;
    return key;
  });
  const _renderRentsProduct = () => {
    return Object.keys(items)
      .sort((a, b) => {
        return sortingOrder.indexOf(items[b]?.item.category) >
          sortingOrder.indexOf(items[a]?.item.category)
          ? 1
          : -1;
      })
      .reduce((acc, element) => {
        if (items[element].item.title === "Printer") {
          return [...acc, element];
        }
        return [element, ...acc];
      }, [])
      .map((key, index) => {
        const item = items[key].item;
        const count = items[key].count;
        const price = item[`${location}_currency`];
        const rows = Math.ceil(Object.keys(items).length / 3) - 1;
        const isItemInLastRow = index + 1 > rows * 3;

        return (
          <ItemWrapper
            style={{ padding: isPDF && "8px 0px" }}
            isItemInLastRow={isItemInLastRow}
            isPDF={isPDF}
            isMobile={isMobile}
            borderTop={
              (index !== 0 && !isMobile && index !== 1) ||
              (isMobile && index !== 0)
            }
            key={key}
          >
            <ItemImg
              src={item.image}
              alt={"item"}
              style={{ width: isPDF && 140, height: isPDF && 140 }}
            />

            <ItemInfo>
              <ItemTitle>
                {item.title && (
                  <Title style={{ fontSize: isPDF && 25 }}>{item.title}</Title>
                )}
                {!isShop && (
                  <Title
                    isMobile={isMobile}
                    style={{ color: "#12637a", fontSize: isPDF && 25 }}
                  >{` x${count}`}</Title>
                )}
              </ItemTitle>

              {item.model && (
                <SubTitle style={{ fontSize: isPDF && 25 }}>
                  {item.model}
                </SubTitle>
              )}

              {price && (
                <ItemPrice>
                  {price.split("\n").map((i) => (
                    <Price style={{ fontSize: isPDF && 25 }} key={i}>
                      {i}
                    </Price>
                  ))}
                </ItemPrice>
              )}
            </ItemInfo>
          </ItemWrapper>
        );
      });
  };

  return (
    <Wrapper>
      <ItemsWrapper isMobile={isMobile} style={{ width: isPDF && "100%" }}>
        <ProductRows isPDF={isPDF} isMobile={isMobile}>
          {_renderRentsProduct(true)}
        </ProductRows>
        {!isPDF && <div style={{ width: "150px" }} />}
      </ItemsWrapper>
    </Wrapper>
  );
};

export { SuggestedProductsForRent };

const Wrapper = styled.div`
  display: flex;
  position: relative;
  @media ${device.mobileS} {
    padding: 30px 40px;
    justify-content: center;
  }
  @media ${device.tablet} {
    padding: 30px 80px;
    justify-content: left;
  }
`;

const ProductRows = styled.div`
  flex-direction: "row";
  @media ${device.mobileS} {
    display: block;
    gap: 0px;
  }
  @media ${device.tablet} {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ isPDF }) => !isPDF && "8%"};
    column-gap: ${({ isPDF }) => isPDF && "80px"};
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  @media ${device.mobileS} {
    flex-direction: column;
    width: 100%;
  }
  @media ${device.tablet} {
    flex-direction: row;
    width: 95%;
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  position: relative;
  border-top: ${({ borderTop, isPDF }) =>
    borderTop && !isPDF ? "1px solid black" : null};
  border-bottom: ${({ isPDF, isItemInLastRow }) =>
    isPDF && !isItemInLastRow ? "2px solid black" : null};

  padding: ${({ borderTop }) => (borderTop ? " 20px 0" : "0 0 20px")};
  @media ${device.mobileS} {
    width: 100%;
  }
  @media ${device.tablet} {
    width: ${({ isPDF }) => (isPDF ? "520px" : "40%")};
  }
`;

const ItemImg = styled.img`
  object-fit: contain;
  width: 120px;
  height: 120px;
  @media ${device.mobileS} {
    margin-right: 30px;
  }
  @media ${device.tablet} {
    margin-right: 50px;
  }
`;

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: calc(100% - 130px);
`;

const ItemTitle = styled.div`
  flex-direction: row;
  display: flex;
  /* @media ${device.mobileS} {
    margin-bottom: 0px;
  }
  @media ${device.tablet} {
    margin-bottom: 24px;
  } */
`;

const Title = styled.div`
  font-weight: bold;
  white-space: pre;
  text-align: left;

  @media ${device.mobileS} {
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;

const ItemPrice = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Price = styled.span`
  white-space: pre-wrap;
  text-align: center;
  padding: 0;
  margin-bottom: 0;
  @media ${device.mobileS} {
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;

const SubTitle = styled.p`
  white-space: pre-wrap;
  margin-bottom: 0;
  text-align: left;
  @media ${device.mobileS} {
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;
